export const SET_CONFIG = 'config/SET';
export const DUPLICATE_CONFIG = 'config/DUPLICATE';
export const ADD_CUSTOM_CONFIG = 'config/ADD_CUSTOM_CONFIG';
export const DELETE_CONFIG = 'config/DELETE';
